import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'

import Header from './Header.js'
import Footer from './Footer.js'
import FilterToolbar from './FilterToolbar.js'
import FileView from './FileView.js'
import FileSearchField from './FileSearchField.js'
import TreeView from './TreeView.js'
import { renderCustomIcons } from './common.js'

import redux from '../redux/index.js'
import { isSelected } from '../util.js'
import { isOutlook } from '../lib/office.js'

const ProjectPage = ({
  pdsId,
  getPageItems,
  getSuggestionItems,
  setOrder,
  setLimit,
  setOffset,
  setSearch,

  resetSelectedItem,

  pageItems,
  totalCount,
  limit,
  offset,
  orderBy,
  order,
  search,
  showFavorites,
  showRecent,

  onFilterFavoriteToggle,
  onFilterRecentToggle,

  onSetSelectedItem,
  onToggleProjectFavorite,
  onClearFileView,
  onPersonWithRoleClick,
  selected,
  sharePointSaveEnabled,
  templateEnabled,
  locale
}) => {
  useEffect(() => {
    getPageItems(pdsId)
  }, [getPageItems, pdsId, limit, offset, orderBy, order, search, showFavorites, showRecent])
  useEffect(() => {
    if (isOutlook()) {
      getSuggestionItems()
    }
  }, [getSuggestionItems, showRecent])

  const checkSelected = isSelected(selected)

  const onFavoriteClick = (project) => {
    const clearFileView = (showFavorites &&
                           project &&
                           project.is_favorite &&
                           checkSelected(project))
    onToggleProjectFavorite(project)
    if (clearFileView) {
      onClearFileView()
    }
  }

  //
  // TODO move this dragging stuff to a separate component
  //

  const [isDragging, setIsDragging] = useState(false)
  const [origDbViewHeight, setOrigDbViewHeight] = useState(0)
  const [origFileViewHeight, setOrigFileViewHeight] = useState(0)
  const [dbViewHeight, setDbViewHeight] = useState(sharePointSaveEnabled ? '60%' : '100%')
  const [fileViewHeight, setFileViewHeight] = useState('40%')
  const [dragY, setDragY] = useState(0)

  const onMouseDown = (e) => {
    e.preventDefault()
    setIsDragging(true)
    setDragY(e.pageY)
    const dbView = document.getElementById('db-view-wrapper')
    setOrigDbViewHeight(dbView.clientHeight)
    const fileView = document.getElementById('file-view-wrapper')
    setOrigFileViewHeight(fileView.clientHeight)
  }

  const onMouseUp = (e) => setIsDragging(false)

  const onMouseMove = (e) => {
    if (isDragging) {
      const diffY = e.pageY - dragY
      setDbViewHeight(origDbViewHeight + diffY)
      setFileViewHeight(origFileViewHeight - diffY)
    }
  }

  //
  // END dragging stuff
  //
  const pageCount = Math.ceil(totalCount / limit)
  const currentPage = Math.ceil(offset / limit) + 1
  const onPageChange = (nextPage) => setOffset((nextPage - 1) * limit)
  const onChangeLimit = (l) => setLimit(l)
  const onSortChange = () => {
    onClearFileView()
    setOrder(orderBy, order === 'asc' ? 'desc' : 'asc')
  }
  const onSearchChange = (str) => {
    if (search !== str) resetSelectedItem()
    setOffset(0)
    setSearch(str)
  }

  const paginatorText = pageCount > 0 ? ` (${currentPage}/${pageCount})` : ''
  const title = `${locale.project_page_title}${paginatorText}`
  const onTemplateManagerClick = (item) => {
    window.open(`https://pds-tm.pergas.se/?pds_id=${item.id}&pds_type=${item.type}`, '_blank')
  }
  const customIcons = renderCustomIcons({
    locale,
    onPersonWithRoleClick,
    onFavoriteClick,
    sharePointSaveEnabled,
    onTemplateManagerClick: templateEnabled && onTemplateManagerClick
  })

  return (
    <>
      <Header
        title={title}
        value={search}
        onSearchChange={onSearchChange}
      />
      <FilterToolbar
        onFilterFavoriteToggle={onFilterFavoriteToggle}
        showFavorites={showFavorites}
        onFilterRecentToggle={onFilterRecentToggle}
        showRecent={showRecent}
        onSortChange={onSortChange}
        order={order}
        pageCount={pageCount}
        currentPage={currentPage}
        onPageChange={onPageChange}
        limit={limit}
        onChangeLimit={onChangeLimit}
      />
      <div
        style={contentWrapperStyle(sharePointSaveEnabled)}
        onMouseMove={onMouseMove}
        onMouseUp={onMouseUp}
      >
        <div id='db-view-wrapper' style={treeViewStyle(dbViewHeight)}>
          <TreeView
            items={pageItems}
            isSelected={checkSelected}
            onItemSelected={(item) => onSetSelectedItem(item, sharePointSaveEnabled)}
            renderCustomIcons={customIcons}
          />
        </div>
        {sharePointSaveEnabled ? <div style={resizeSliderStyle} onMouseDown={onMouseDown} /> : null}
        {sharePointSaveEnabled ? <div id='file-view-wrapper' style={fileViewStyle(fileViewHeight)}><FileView /></div> : null}
      </div>
      {sharePointSaveEnabled ? <div style={fileSearchFieldStyle}><FileSearchField /></div> : null}
      <div style={footerStyle}><Footer /></div>
    </>
  )
}

// TODO refactor these styles, maybe use styled-components?

const border = '1px solid #a3a3a3'

const contentWrapperStyle = (sharePointSaveEnabled) => {
  return {
    position: 'absolute',
    top: 90,
    bottom: sharePointSaveEnabled ? 90 : 50,
    width: '100%'
  }
}

const treeViewStyle = (height) => {
  return {
    background: 'white',
    overflow: 'auto',
    borderTop: border,
    borderLeft: border,
    borderRight: border,
    height
  }
}

const fileSearchFieldStyle = {
  background: 'white',
  position: 'absolute',
  bottom: 50,
  width: '100%'
}

const resizeSliderStyle = {
  width: '100%',
  height: 3,
  borderTop: border,
  borderLeft: border,
  borderRight: border,
  background: 'rgb(202, 221, 204)',
  cursor: 'ns-resize'
}

const fileViewStyle = (height) => {
  return {
    background: 'white',
    overflow: 'auto',
    height,
    border
  }
}

const footerStyle = {
  position: 'absolute',
  bottom: 0,
  width: '100%'
}

const mapStateToProps = (state) => {
  const {
    pageItems,
    totalCount,
    limit,
    offset,
    orderBy,
    order,
    search,
    showFavorites,
    showRecent
  } = state.project

  return {
    pageItems: pageItems.map(p => {
      const name = `${p.name} (${p.collection_name})`
      return { ...p, name }
    }),
    totalCount,
    limit,
    offset,
    orderBy,
    order,
    search,
    showFavorites,
    showRecent,

    selected: state.selected.current,
    locale: state.locale.strings,
    sharePointSaveEnabled: state.login.userData.sharePointSaveEnabled,
    templateEnabled: state.login.userData.sharePointTemplatesEnabled
  }
}

const mapDispatchToProps = (dispatch) => {
  const {
    dialog,
    files,
    project,
    selected
  } = redux.actions
  return {
    getPageItems: (pdsId) => {
      dispatch(project.getPageItems(pdsId))
    },
    getSuggestionItems: () => {
      dispatch(project.getSuggestionItems())
    },
    setOrder: (orderBy, order) => dispatch(project.setOrder(orderBy, order)),
    setLimit: (limit) => dispatch(project.setLimit(limit)),
    setOffset: (offset) => dispatch(project.setOffset(offset)),
    resetSelectedItem: () => dispatch(selected.resetSelectedItem()),
    setSearch: (search) => {
      dispatch(project.setSearch(search))
    },

    onSetSelectedItem: (item, sharePointSaveEnabled) => {
      dispatch(selected.setSelectedItem(item))
      if (sharePointSaveEnabled) {
        dispatch(files.getRootFolder(item))
      }
    },
    onPersonWithRoleClick: (contactId, item) => {
      dispatch(dialog.showPeopleDialog(contactId, item.person_role))
    },
    onToggleProjectFavorite: (p) => {
      dispatch(project.toggleFavorite(p))
    },
    onClearFileView: () => {
      dispatch(selected.resetSelectedItem())
    },
    onFilterFavoriteToggle: () => {
      dispatch(selected.resetSelectedItem())
      dispatch(project.toggleShowFavorites())
    },
    onFilterRecentToggle: () => {
      dispatch(selected.resetSelectedItem())
      dispatch(project.toggleShowRecent())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectPage)
